module.exports = __webpack_public_path__ + "99c37bf21b8704b5784b633effadafe1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-italic/opensans-italic.woff
// module id = ./src/styles/fonts/opensans-italic/opensans-italic.woff
// module chunks = index